import _ from 'lodash';
import { computed, Ref, getCurrentInstance } from '@vue/composition-api';

export type RefState<State> = {
  [Property in keyof State]: Ref<State[Property]>;
};

type Property<State> = keyof State;

export function useLegacyActionDeskStore() {
  const vm = getCurrentInstance()!;

  /** An equivalent of Vuex 4 "useStore" */
  function useState<State>(args: {
    path: string;
    properties: Property<State>[];
  }) {
    const { path = '', properties } = args;

    const obj = {} as RefState<State>;
    for (const property of properties) {
      const getter = path ? `${path}.${String(property)}` : property;
      obj[property] = computed(() => _.get(vm.proxy.$store.state, getter));
    }

    return obj;
  }

  return { store: vm.proxy.$store, useState };
}
